<script>
	// Stores
	import { linkWhatsappGeral } from '../store.js';
</script>

<span class="botaowhatsapp" style="position: fixed; right: 5px; z-index: 100; bottom: 60px; display: inline-block;">
	<a href="{$linkWhatsappGeral}" target="_blank">
		<img src="/assets/images/btnWhatsapp.png" alt="Boleto via whatsapp" title="Boleto via whatsapp" style="border: 0px;">
	</a>
</span>